import React from 'react'
import { orderAmount} from '../share/order_helper'
import { toDate, toDateHuman} from '../share/date_helper'
import { Link } from 'react-static'
import ItemMenu from './ItemMenu'
import {Tooltip} from 'reactstrap'

export default class Order extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuOpen: false }
  }

  toggleMenu = () => {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  render(){
    const {order} = this.props
    const amount = orderAmount(order,'de-DE')

    // USE FONT AWESOME HERE
    return (
      <tr>
        <td>
          {order.cancelled && <i className="fas fa-times-circle text-default"/>} {' '}
          {order.payedAt && <i className="fas fa-hand-holding-usd text-success"/>}{' '}
          {order.shippedAt && <i className="fas fa-truck-moving text-success"/>}
        </td>
        <td>
          {order.date ? toDateHuman(order.date) : 'Datum unbekannt'}
        </td>
        <td className="text-nowrap">
          <Link to={`/orders/${order.id}/show`}>{order.number || 'Unknown'}</Link>
        </td>
        <td>{order.client}</td>
        <td>{amount.totalGrossHuman}€</td>
        <td>{order.orderSource}</td>
        <td>
          {order.cancelled && order.cancellationCause}
        </td>
        <td>
          <ItemMenu>
            <Link className="dropdown-item" to={`/orders/${order.id}/show`}>Anzeigen</Link>
            <Link className="dropdown-item" to={`/orders/${order.id}/invoice`}>Rechnung</Link>
          </ItemMenu>
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/OrderItem.js